export default "__VITE_ASSET__C6wtMFz6__"